import React from "react";
import { object, shape } from "prop-types";
import { getCollectionTemplate } from "../get-collection-template";
//import CustomRadioPlayer from "../molecules/radio-player-custom/custom-radio-player";
import { LazyCollection, LazyLoadImages, replaceAllStoriesInCollection, WithPreview } from "@quintype/components";
import "./home.m.css";

export const HomePage = ({ data }) => {
  return (
    <div>
      <div>
        <LazyLoadImages>
          <LazyCollection collection={data.collection} collectionTemplates={getCollectionTemplate} lazyAfter={22} />
        </LazyLoadImages>
      </div>
    </div>
  );
};

HomePage.propTypes = {
  data: shape({
    collection: object,
  }),
};

export const HomePagePreview = WithPreview(HomePage, (data, story) =>
  Object.assign({}, data, {
    collection: replaceAllStoriesInCollection(data.collection, story),
  })
);
